module.exports = __webpack_public_path__ + "static/media/high_school_zone.64d90f89.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/20-21/high_school_zone.pdf
// module id = 212
// module chunks = 0